export default{
    filialpadrao: {
        idcliente         : null,//id do cliente no sac
        idclientepadrao   : null,//cliente padrão pra emissão dos pedidos
        codfil            : null,
        descfil           : '',
        fantasia          : '',
        nomecliente       : '',
        idplano           : null,
        tipoplano         : 0,
        descplano         : '',
        idtabela          : null,
        percentrada       : 0,
        permitedesconto   : 0,
        formulacustopro   : '',
        logo              : '',
        idestoque         : null,
        descestoque       : '',
        defvendedorcliente: 0,
        plnc              : 1,
        entregaauto       : 0,  
        reservaauto       : 0,
        produtosporfilial : 0
    },
    usuario: {
        id          : null,
        nome        : '',
        foto        : '',
        descgrupo   : '',
        idclientesac: null,
        dbcliente   : '',
        sistema     : '',
        adrsrv      : '',
        tpsistema   :  0,
        todasfiliais: null,
        operaperfilfluxo: null,
        todastabelas: null,
        idvendedor  : null,
        nomevendedor: '',
        descontoprodutos : 0,
        descontoprodutosprazo : 0,
        descontoservicos : 0,
        descontojuros    : 0,
        descontomulta    : 0,
        descontotit      : 0,
        cardresumopedidos: 0,
        cardfinanceiro   : 0,
        cardtop5produtos : 0,
        cardgiroproduto  : 0,
        cardvendedores   : 0,
        cardcompra       : 0,
        cardmetas        : 0,
        cardmetaindividual: 0,
        carddemotecnico  : 0,
        cardpicovendas   : 0,
        carddemoresultado: 0,

        cardtotalestoque          : 0,
        cardcomprasfiliais        : 0,
        cardcomprassetores        : 0,
        cardcomprasgrupos         : 0,
        cardcomprasmarcas         : 0,
        cardmetafilial            : 0,
        cardvendasvendedores      : 0,
        cardvendassubgrupos       : 0,
        cardvendassetores         : 0,
        cardvendasplanospagamento : 0,
        cardvendasmunicipios      : 0,
        cardvendasmarcas          : 0,
        cardvendasgrupos          : 0,
        cardvendasformaspagamento : 0,
        cardvendasfiliais         : 0,
        cardvendascategorias      : 0,
        cardvariacaofaturamento   : 0,
        cardprevisaorecebimento   : 0,
        cardprevisaopagamento     : 0,
        cardprodutosparados       : 0, 
        cardfaturamentofilial     : 0,
        cardsaldocaixa            : 0,

        exibicaocard              : 0,

        definirsenhalogin: 0,
        limitecreditoautorizar: 0,
        qtddiastolatraso: 0,
        qtddiasbloqvenda: 0,
        receberinfsistema: 0,
        estoquegeralconsultas: 0,
        tabelasusuarios: null,
        senhausu: '',  
    },
    configpaths: {
        // pathcontrole    : 'https://www.rillsoft-app.cloud/controller/',
        // pathselect2     : 'https://www.rillsoft-app.cloud/controller/select2remoto.php',
        // pathselect2sql  : 'https://www.rillsoft-app.cloud/controller/select2sql.php',
        // pathimagens     : 'https://www.rillsoft-app.cloud/',
        // patharquivos    : 'https://www.rillsoft-app.cloud/',
        pathcontrole    : '',
        pathselect2     : '',
        pathselect2sql  : '',
        pathimagens     : '',
        patharquivos    : '',  
        pathvideos      : '',       
        pathconferencias: 'arquivos/manager/conferencias/',                        
        pathretornos    : 'arquivos/manager/retornos/',        
        pathofx         : 'arquivos/manager/ofx/',
        pathimgprodutos : 'imagens/manager/produtos/',
        pathimgpedidos  : 'imagens/manager/pedidos/',
        pathimgfiliais  : 'imagens/manager/filiais/',
        pathimgclientes : 'imagens/manager/clientes/',
        pathimgusuarios : 'imagens/manager/usuarios/',
        pathcertificados: 'arquivos/manager/certificados/',
        pathtarefas     : 'arquivos/manager/tarefas/',
        pathvideosexercicios : 'videos/manager/exercicios/',
    },
    perfilusuario:[],
    perfiltiposis:[],
    consultaprodutos:{
        abrirtela    : false
    },
    listaprodutosretornoconsulta:{
        lstprod      : []
    },
    listaprodutoretorno:{
        lstprodutos      : []
    },
    produtoretornoconsulta: {
        idproduto    : null
    },
    consultaclientes:{
        abrirtela    : false
    },
    clienteretornoconsulta: {
        idcliente    : null
    },
    consultafornecedores:{
        abrirtela    : false
    },
    fornecedorretornoconsulta: {
        idfornecedor    : null
    },    
    consultapedidos:{
        abrirtela    : false
    },
    pedidoretornoconsulta: {
        idpedido    : null
    }, 
    consultapedidoscompra:{
        abrirtela    : false
    }, 
    pedidocompraretornoconsulta: {
        idpedido    : null
    }, 
    cadastrorapidocliretorno: {
        idcliente    : null
    },       
    sidenav:{
        fechar : false
    },
    retornobaixareceber:{
        retorno : 0// 0 - Aguardando, 1 - Baixa realizada
    },
    retornobaixapagar:{
        retorno : 0// 0 - Aguardando, 1 - Baixa realizada
    },    
    consultatituloscob:{
        abrirtela    : false
    },
    tituloscobretornoconsulta: {
        lsttituloscobret : []
    },
    rotinatarefas:{
        abrirtela    : false
    },
    atzcoletor:{
        atualizar : false,
        itenscoletor: []
    },
    verificalib:{
        verificar : false
    },   
    vizuestoque:{
        abrirtela    : false,
        idproduto    : null,
        descproduto  : ''
    },            
}